import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {createSelector} from 'reselect';
import type {RootState} from '../../types';
import type {BasketState} from './types';

const basketSelector = (state: RootState) => state.basket;

export const basketSlice = createSlice({
	name: 'basket',
	initialState: {},
	reducers: {
		receiveBasket: (state: BasketState, action: PayloadAction) => {
			return Object.assign(
				{
					productItems: [],
					giftCertificateItems: [],
					applicablePaymentMethods: state?.applicablePaymentMethods || [] // Only applicablePaymentMethods must be saved from the previous version, as they are not included in a standard response
				},
				action.payload
			);
		},
		receiveApplicablePaymentMethods: (state: BasketState, action: PayloadAction) => {
			Object.assign(
				state,
				{
					applicablePaymentMethods: []
				},
				{
					applicablePaymentMethods: action.payload
				}
			);
		},
		receiveInitializationId: (state: BasketState, action: PayloadAction) => {
			Object.assign(
				state,
				{
					initializationId: action.payload
				}
			);
		},
		receiveBasketId: (state: BasketState, action: PayloadAction) => {
			Object.assign(
				state,
				{
					basketId: action.payload
				}
			);
		},
		resetBasket: () => {
			return {};
		}
	}
});

export const {
	receiveBasketId,
	receiveBasket,
	receiveApplicablePaymentMethods,
	receiveInitializationId,
	resetBasket
} = basketSlice.actions;

export const selectBasket = createSelector(basketSelector, (basket) => basket);

export default basketSlice.reducer;
